var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-app',{attrs:{"params":_vm.f7params}},[_c('f7-statusbar'),_c('f7-view',{attrs:{"main":""}},[_c('Home')],1),_c('pre',[_vm._v(_vm._s(_vm.deviceReady))]),_c('pre',[_vm._v(_vm._s(_vm.f7ready))]),_c('pre',[_vm._v(_vm._s(_vm.allReady))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }